import * as React from 'react';
import styled from '../theme';

interface ILoadingProps {
    fixposition?: boolean
}

class LoadingIcon extends React.Component<ILoadingProps>{
    public render() {
        return (
            <MainWrapper fixposition={this.props.fixposition}>
                <Wrapper fixposition={this.props.fixposition}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="25 25 50 50">
                        <circle className="outer" cx="50" cy="50" r="20">
                            <animateTransform attributeName="transform" dur="2s" from="0 50 50" repeatCount="indefinite" to="360 50 50" type="rotate" />
                        </circle>
                    </svg>
                </Wrapper>
            </MainWrapper>
        )

    }
}

export default LoadingIcon

const Wrapper = styled<ILoadingProps, 'div'>('div')`
    left: 50%;
    top: ${(props: any) => props.fixposition ? '85%': '50%'};
    transform: translate(-50%, -50%);
    position: fixed;

    .outer { 
        animation: outer 1.5s ease-in-out infinite; 
    }

    svg {
        width: 30vw;
        height: 30vw;
        max-width: 200px;
        max-height: 200px;
    }

    circle { 
        fill: none; 
        stroke: #262525; 
        stroke-width: 1; 
    }

    @keyframes outer {
        0% { stroke-dasharray: 1,200; stroke-dashoffset: 0; }
        50% { stroke-dasharray: 89,200; stroke-dashoffset: -35; }
        100% { stroke-dasharray: 89,200; stroke-dashoffset: -124; }
    }

`

const MainWrapper = styled<ILoadingProps, 'div'>('div')`
    width: 100vw;
    height:${(props: any) => props.fixposition ? 'initial': '100vh'};
    position: absolute;
    top: 0;
    left: 0;
    background: #F8F7F5;
`



// WEBPACK FOOTER //
// ./src/components/Loading.tsx